import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./company-lists.actions.component.html')
})
export class CompanyListsActionsComponent {
  @Input() record: any;

  @Output() onCancelClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditClick  : EventEmitter<any> = new EventEmitter();
  @Output() onSaveClick  : EventEmitter<any> = new EventEmitter();
}
